import useTranslation from 'next-translate/useTranslation';

import { Translate } from '@core/constant';

import { IconCurrency } from '../icon';
import { Box } from '../layout';
import { InputText } from './InputText';
import { InputBudgetProps } from './interface-input';

export const InputBudget = ({ currency, ...inputProps }: InputBudgetProps) => {
  const { t: tWidget } = useTranslation(Translate.common.WIDGET);

  return (
    <Box position={'relative'} width={'100%'}>
      <InputText
        {...inputProps}
        name={'price'}
        fontSize={'14px'}
        placeholder={tWidget('budgetCalculator.addBudget')}
        withLeftSideIcon
      />
      <Box position={'absolute'} top={'16px'} left={'16px'}>
        <IconCurrency currency={currency} />
      </Box>
    </Box>
  );
};
